import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { IFreebetToken } from '@frontend/oxygen/bet-history-utils';

import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { DeviceService } from '../../../core/services/device/device.service';
import { IDialogParams } from '../../../core/services/dialogService/dialog-params.model';
import { FreeBetsService } from '../../../core/services/freeBets/free-bets.service';
import { WindowRefService } from '../../../core/services/windowRef/window-ref.service';
import { AbstractDialogComponent, IOxygenDialog } from '../oxygenDialogs/abstract-dialog';

interface IFilterToken {
    category: string;
    count: number;
}
@Component({
    selector: 'odds-boost-popup',
    templateUrl: './odds-boost-popup.component.html',
    styleUrls: ['./odds-boost-popup.component.scss'],
    standalone: false,
})
export class OddsBoostPopupComponent extends AbstractDialogComponent implements OnInit {
    @ViewChild('oddsBoostPopup', { static: true }) override dialog: IOxygenDialog;
    oddsBoostData: IDialogParams;
    filteredTokens: IFilterToken[];
    sortedTokensArr: IFreebetToken[] = [];
    isWrapper: boolean = false;
    constructor(
        device: DeviceService,
        windowRef: WindowRefService,
        private freeBetService: FreeBetsService,
        private pubsub: PubSubService,
        protected router: Router,
    ) {
        super(device, windowRef);
    }

    /**
     * Open oppthe dialog
     */
    override open(): void {
        this.oddsBoostData = this.params;
        this.isWrapper = this.device.isWrapper;
        if (Object.keys(this.oddsBoostData) && this.oddsBoostData.tokens?.length > 0) {
            const tokensData: IFreebetToken[] = Object.values(this.oddsBoostData.tokens).flat() as IFreebetToken[];
            this.freeBetService.getOddsBoostsWithCategories(tokensData).subscribe((data: any) => {
                this.customSortOddsboostTokens(data);
            });
        }
    }

    /**
     * Method to custom sort the odds boost tokens
     */
    customSortOddsboostTokens(reqTokensData: IFreebetToken[]): void {
        const categoryOrder = ['Any', 'Football', 'Horse Racing', 'A-Z'];
        const customSort = (a: IFreebetToken, b: IFreebetToken) => {
            const AcategoryName = a.categoryName || 'Any';
            const BcategoryName = b.categoryName || 'Any';
            const indexA = categoryOrder.indexOf(AcategoryName);
            const indexB = categoryOrder.indexOf(BcategoryName);

            if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB;
            } else if (indexA !== -1) {
                return -1; // a comes first
            } else if (indexB !== -1) {
                return 1; // b comes first
            }

            return AcategoryName.localeCompare(BcategoryName); // Fallback for alphabetical sorting
        };
        const sortedTokensData = [...reqTokensData].sort(customSort);
        this.sortedTokensArr = sortedTokensData;
        this.getFilteredTokens(this.sortedTokensArr);
    }

    /**
     * To filter the tokens based on sports
     * @param tokensGroup - list of tokens
     */
    getFilteredTokens(tokensGroup: IFreebetToken[] = []): void {
        const filterTokens = tokensGroup.reduce<IFilterToken[]>((acc, obj) => {
            if (!obj.categoryName) {
                obj.categoryName = 'Multi-Sport';
            }
            const found = acc.find((el) => el.category === obj.categoryName);
            if (found) {
                found.count += 1;
            } else {
                acc.push({ category: obj.categoryName, count: 1 });
            }
            return acc;
        }, []);
        if (filterTokens.length > 5) {
            const actualTokens = filterTokens;
            const otherTokensCount = actualTokens.splice(4).reduce<number>((total, token) => {
                return total + token.count;
            }, 0);

            this.filteredTokens = filterTokens.splice(0, 4);
            this.filteredTokens.push({ category: 'Others', count: otherTokensCount });
        } else {
            this.filteredTokens = filterTokens.splice(0, 5);
        }

        super.open();
    }

    /**
     * Navigate when view all boosts link is clicked
     */
    viewAllBoosts(): void {
        if (this.device.isMobile) {
            this.pubsub.publish(this.pubsub.API['show-slide-out-betslip'], false);
            this.pubsub.publish('isBetSlipOpened', false);
        }
        this.router.navigateByUrl('/oddsboost');
        super.closeDialog();
    }
}
